import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  setPeriod({ params: { period } }) {
    VisitHelper.update(["campaigns_reporting_graph"], { "graph[by_period]": period })
  }

  setValue({ target: { value } }) {
    VisitHelper.update(["campaigns_reporting_graph"], { "graph[value]": value })
  }
}
